import React from 'react'
import '../App.css';
import {Button} from './Button';
import './HeroSection.css';

function HeroSection() {
    return (
        <div className = 'hero-container'>
            
            
            <h1>"Hello World!"</h1>
            <p>
            My Name is Sirjan Chawla , I am a graduate from the University of Alberta.

            I love to learn by working on projects, just like this one. I have 

            worked on various fun projects, you can find them by clicking on "My other projects" . Apart

            from computer science, I often like to read articles about the financial and economic sectors.

            I hope you have a wonderful day/night. Enjoy navigating through the website!. 
            </p>
             
                
            
            <link rel="preconnect" href="https://fonts.gstatic.com"></link>
            <link href="https://fonts.googleapis.com/css2?family=Lobster+Two&display=swap" rel="stylesheet"></link>
            
            
        </div>
    
    )
}


export default HeroSection;
